import components from './data.js'
import PortConnections from '../../Components/Assembly/PortConnections'
import { defaultAssemblyPageAi } from '../../source/assemblyPageAiData.js'

if (sessionStorage.getItem('assemblyTwo')) {
    var assembly = sessionStorage.getItem('assemblyTwo')
    assembly = JSON.parse(assembly)
} else {
    var assembly = {
        components: components,
        PortConnections: PortConnections,
        workspace: {
            bibox: { top: 208, left: 328 },
            components: {},
            offset: { top: 0, left: 0 },
            scale: 1,
        },
        height: document.body.clientHeight,
        width: document.body.clientWidth,
        assemblyPageAi: defaultAssemblyPageAi,
    }
}

const assemblyTwoSelec_Reducer = (state = assembly, action) => {
    var { payload } = action
    var workspace = payload

    switch (action.type) {
        case 'ASSEMBLY_TWO_SELECTION':
            var workspace = payload
            var data = { ...state, workspace }
            sessionStorage.setItem('assemblyTwo', JSON.stringify(data))
            return data

        case 'PORT_CONNECTION_TWO':
            var PortConnections = payload
            var data = { ...state, PortConnections }
            sessionStorage.setItem('assemblyTwo', JSON.stringify(data))
            return data

        case 'sizesHelper':
            var { width, height } = payload
            var data = { ...state, width, height }
            sessionStorage.setItem('assemblyTwo', JSON.stringify(data))
            return data

        case 'ASSEMBLY_PAGE_AI_TWO':
            var assemblyPageAi = payload
            var data = { ...state, assemblyPageAi }
            sessionStorage.setItem('assemblyTwo', JSON.stringify(data))
            return data

        case 'ASSEMBLY_TWO':
            var { PortConnections, width, height, workspace, assemblyPageAi } =
                payload
            if (!assemblyPageAi) {
                assemblyPageAi = defaultAssemblyPageAi
            }
            var data = {
                ...state,
                PortConnections,
                width,
                height,
                workspace,
                assemblyPageAi,
            }
            return data

        default:
            sessionStorage.setItem('assemblyTwo', JSON.stringify(state))
            return state
    }
}

export default assemblyTwoSelec_Reducer
